// src/services/sessionSync.js
// Syncs chat sessions to the server for persistence across devices/browsers.
// Falls back to localStorage-only if server is unreachable.

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_KEY = process.env.REACT_APP_API_KEY || '';

const headers = () => ({
  'Content-Type': 'application/json',
  ...(API_KEY ? { 'X-API-Key': API_KEY } : {}),
});

/**
 * Load sessions from server for a terminal type.
 * @param {string} terminal - 'forge' | 'stratos' | 'chat'
 * @returns {Array|null} sessions array or null on failure
 */
export async function loadSessions(terminal) {
  try {
    const res = await fetch(`${BASE}/sessions/?terminal=${terminal}`, { headers: headers() });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

/**
 * Save a single session to the server.
 * @param {string} terminal
 * @param {Object} session - { id, title, messages, createdAt, mode? }
 */
export async function saveSession(terminal, session) {
  try {
    await fetch(`${BASE}/sessions/`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({
        terminal,
        id: session.id,
        title: session.title,
        messages: session.messages,
        mode: session.mode || null,
        createdAt: session.createdAt,
      }),
    });
  } catch {
    // silent — localStorage is the fallback
  }
}

/**
 * Delete a session from the server.
 * @param {string} sessionKey
 */
export async function deleteSession(sessionKey) {
  try {
    await fetch(`${BASE}/sessions/${sessionKey}`, {
      method: 'DELETE',
      headers: headers(),
    });
  } catch {
    // silent
  }
}
